module.exports = __webpack_public_path__ + "media/images/v5/overlay-642ddff91002098761d2cebeb4da4131.png";